/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
    try {
        const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader');

        return new Promise<void>((resolve, reject) => {
            const timeout = setTimeout(() => {
                console.log('Font loading timeout - continuing without custom fonts');
                resolve();
            }, 5000);

            webFontLoader.load({
                google: {
                    families: ['Roboto:100,300,400,500,700,900&display=swap']
                },
                active: () => {
                    clearTimeout(timeout);
                    console.log('Fonts loaded successfully');
                    resolve();
                },
                inactive: () => {
                    clearTimeout(timeout);
                    console.log('Font loading failed - continuing with fallback fonts');
                    resolve();
                },
                fontinactive: () => {
                    clearTimeout(timeout);
                    console.log('Some fonts failed to load - continuing with available fonts');
                    resolve();
                }
            });
        });
    } catch (error) {
        console.log('Font loading error - continuing without custom fonts:', error);
        return Promise.resolve();
    }
}
